import { Check, Clipboard } from "lucide-react";
import { useState } from "react";
import type { CodeExample } from "../types/api";

function highlightLua(code: string) {
  const escaped = code
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  return escaped
    .replace(/(--[^\n]*)/g, '<span class="tok-comment">$1</span>')
    .replace(/("[^"\n]*"|'[^'\n]*')/g, '<span class="tok-string">$1</span>')
    .replace(/\b(local|function|end|if|then|else|elseif|for|while|do|return|true|false|nil)\b/g, '<span class="tok-keyword">$1</span>')
    .replace(/\b(\d+(?:\.\d+)?)\b/g, '<span class="tok-number">$1</span>')
    .replace(/\b(workspace|game|script|print|pairs|ipairs|task)\b/g, '<span class="tok-built-in">$1</span>');
}

export function CodeBlock({ example }: { example: CodeExample }) {
  const [copied, setCopied] = useState(false);

  async function copyCode() {
    await navigator.clipboard.writeText(example.code);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  }

  return (
    <div className="code-block">
      <div className="code-toolbar">
        <div><span className="window-dot dot-red" /><span className="window-dot dot-yellow" /><span className="window-dot dot-green" /></div>
        <span>{example.title || "example.lua"}</span>
        <button onClick={copyCode}>{copied ? <Check size={15} /> : <Clipboard size={15} />}{copied ? "Copied" : "Copy code"}</button>
      </div>
      <pre><code dangerouslySetInnerHTML={{ __html: highlightLua(example.code.trim()) }} /></pre>
    </div>
  );
}
